import Lng from "../3x1010/Lng.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import { SecurityAcl, SecurityAclContext, AuthCheckAcl } from "../Security.js";
import { Game, GameDomande } from "./classes/Game.js";


export default class PageCommon {
  constructor() {
    this.resetGame();
  }

  resetGame(type=null) {
    this.currentGameConfig={type:type,level:null,mc:null};
    // console.log(this.currentGameConfig);
    if (this.currentGame) {
      this.currentGame.destructor();
    }
    this.currentGame=null;
  }

  startGame(mc) {
    this.currentGameConfig.mc=mc;
    // console.log(this.currentGameConfig);
    let difficoltatxt='';
    switch(this.currentGameConfig.level) {
        case 'easy': difficoltatxt = TheApp.Res[TheApp.Locale]["Game.Level.Label"] + ' ' + TheApp.Res[TheApp.Locale]["Game.Level.Easy.Label"];break;
        case 'normal': difficoltatxt = TheApp.Res[TheApp.Locale]["Game.Level.Label"] + ' ' + TheApp.Res[TheApp.Locale]["Game.Level.Medium.Label"];;break;
        case 'hard': difficoltatxt = TheApp.Res[TheApp.Locale]["Game.Level.Label"] + ' ' + TheApp.Res[TheApp.Locale]["Game.Level.Hard.Label"];;break;
    }
    $('.js-level-txt',mc).text(difficoltatxt);
    this.currentGame = Game.getInstance(this.currentGameConfig, this.uidpath, (punti)=>{
      $(".current-game").hide();
      $('.js-game-scores').text(punti.toLocaleString()+' punti!');
      if (punti>0) {
        $('.js-nopoints-feedback').hide();
        $('.js-points-feedback').show();
      }
      else {
        $('.js-nopoints-feedback').show();
        $('.js-points-feedback').hide();
      }
      $(".js-step-3").show();
    });
  }

  init($data) {
    // console.log('data',$data);
    this.uidpath = $data?.uidpath??"";

    // Common functions:start

    // ignore right-click and drag on imgs    
    if (document.querySelector("img")) {
      let imgs = document.querySelectorAll("img");
      for (let i = 0; i < imgs.length; i++) {
        imgs[i].addEventListener("contextmenu", (e) => {
          e.preventDefault();
        });
        imgs[i].ondragstart = () => {
          if (window.innerWidth > 768) {
            return false;
          }
        }
      }
    }

    let main_nav = ".js-main-nav";
    let cover_intro = ".js-cover-intro";
    if ((document.querySelector(main_nav)) && (document.querySelector(cover_intro))) {
      this.checkCoverIntro(main_nav, cover_intro);
      // adjust cover-intro spacings
      //  this.adjustCoverPaddingTop(main_nav, cover_intro);
    }
    let main_nav_mobile = ".js-main-nav-mobile";
    if (document.querySelector(main_nav_mobile)) {
      this.initMobileNav(main_nav_mobile);
    }

    let sidebar = "aside";
    if (document.querySelector(sidebar)) {
      sidebar = document.querySelector(sidebar);
      this.initSidebarMobile(sidebar);
    }

    // logout
    $(".js-logout").on("click", this.doLogout.bind(this));

    // init gallery lightbox
    let imgs = $(".img-preview");
    let current_index = 0;
    // init swiper
    if ($(".js-swiper-lightbox")) {
      let swiper_lightbox = new Swiper(".js-swiper-lightbox", {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: ".js-lightbox-btn-next",
          prevEl: ".js-lightbox-btn-prev",
        },
        breakpoints: {
          821: {
            allowTouchMove: false
          }
        }
        //breakpoints: {
        //  768: {
        //    spaceBetween: 24
        //  }
        //}
      });
      // console.log(imgs[0]);
      // console.log(document.querySelectorAll(".img-preview"));
      for (let i = 0; i < imgs.length; i++) {
        $(imgs[i]).on("click", (e) => {
          imgs.closest("figure").addClass("no-pointer-evs");
          // set current index
          current_index = i;
          // console.log(current_index);
          // slide to current index
          swiper_lightbox.slideTo(current_index);
          // show swiper
          $(".js-img-lightbox-wrap").fadeIn(500);
        });
      }
    }
    // show captions
    $(".js-icon-observe").on("click", (e) => {
      // console.log("click");
      $(".js-icon-observe").toggleClass("is-hidden");
      $(".swiper").addClass("swiper-no-swiping");
      setTimeout(() => {
        $(".swiper").removeClass("swiper-no-swiping");
      }, 700);
      if ($(".js-icon-observe").hasClass("is-hidden")) {
        $(".js-img-lightbox-cont").addClass("has-visible-captions");
      } else {
        $(".js-img-lightbox-cont").removeClass("has-visible-captions");
      }
    });
    // close lightbox
    $(".js-lightbox-close").on("click", (e) => {
      $(".js-img-lightbox-wrap").fadeOut(500);
      imgs.closest("figure").removeClass("no-pointer-evs");
    });

    // open contacts layer
    if ($(".js-open-contacts")) {
      $(".js-open-contacts").on("click", (e) => {
        $(".js-contacts").show();
      });
    }
    $(".js-contacts-close").on("click", (e) => {
      $(".js-contacts").hide();
    });

    // init games layers
    let btn_start_game = ".js-start-game";
    let game_layer = ".js-game-layer";
    if (document.querySelector(btn_start_game) && document.querySelector(game_layer)) {
      this.initGameLayers(btn_start_game, game_layer);
    }
    // Common functions:end    

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGECOMMON_INITED);
    } catch (error) {
      console.log(error);
    }
    StateManager.initialize();
    try {
      let stat = StateManager.getViewState("frm");
      if (stat.m === "u") {
        // console.log("IN UPDATE");
      }
    } catch (e) {
      // console.log(e);
    }
  }

  // addclass to btn signup if the page intro has no imgs
  checkCoverIntro(main_nav, cover_intro) {
    main_nav = document.querySelector(main_nav);
    if (!document.querySelector(cover_intro)) {
      let btn_signup = main_nav.querySelector(".js-btn-primary");
      btn_signup.classList.add("is-accent");
    }
  }

  // add padding-top to cover-intro to prevent text overlap on header
  //adjustCoverPaddingTop(main_nav, cover_intro) {
  //  main_nav = document.querySelector(main_nav);
  //  cover_intro = document.querySelector(cover_intro);
  //  let main_nav_h = main_nav.offsetHeight;
  //  cover_intro.style.paddingTop = main_nav_h + "px";

  //  //window.onresize = (e) => {
  //  //  cover_intro.style.paddingTop = main_nav_h + "px";
  //  //}
  //}

  // init mobile navigation
  initMobileNav(main_nav_mobile) {
    let btn = ".js-nav-toggle-btn";
    let close_btn = ".js-mn-overlay";
    if (document.querySelector(btn)) {
      main_nav_mobile = $(main_nav_mobile);
      btn = $(btn);
      close_btn = $(close_btn);
      btn.on("click", (e) => {
        btn.toggleClass("open");
        main_nav_mobile.toggleClass("open");
        if (!main_nav_mobile.hasClass("open")) {
          main_nav_mobile.slideUp(250);
        } else {
          main_nav_mobile.slideDown(250);
        }
        // close sidebar nav
        if (document.querySelector("aside")) {
          let sidebar = $("aside");
          if (sidebar.hasClass("open")) {
            sidebar.removeClass("open");
          }
        }
        // open & close mobile menu        
        if (close_btn.is(":visible")) {
          close_btn.on("click", (e) => {
            if (main_nav_mobile.hasClass("open")) {
              btn.removeClass("open");
              main_nav_mobile.removeClass("open");
              main_nav_mobile.slideUp(250);
            }
          });
        }
      });
    }
  }

  // init sidebar mobile
  initSidebarMobile(sidebar) {
    let btn = ".js-toggle-sidebar-mobile";
    if (document.querySelector(btn)) {
      btn = document.querySelector(btn);
      btn.addEventListener("click", (e) => {
        sidebar.classList.toggle("open");
        // close mobile nav-menu
        if ($(".main-nav-mobile").hasClass("open")) {
          $(".js-nav-toggle-btn").removeClass("open");
          $(".main-nav-mobile").removeClass("open");
          $(".main-nav-mobile").slideUp(125);
        }
      });
    }
  }

  /*
   * TEMP:START
   */
  // init games
  initGameLayers(btn_start_game, game_layer) {
    btn_start_game = document.querySelectorAll(btn_start_game);
    let games = document.querySelectorAll(game_layer);
    // show game
    for (let i = 0; i < btn_start_game.length; i++) {
      let btn_type = btn_start_game[i].dataset.game;
      btn_start_game[i].addEventListener("click", (e) => {
        e.preventDefault();
        this.currentGameConfig.type=btn_type;
        // console.log(this.currentGameConfig);
        $(".js-step-livello").show();
        $(".js-game-layer-menu").fadeIn();
        
        //$(".js-btn-start-game").attr("data-start", `${btn_type}`);
        //if (btn_type === games[i].dataset.game) {
        //  $(games[i]).fadeIn();
        //  $(games[i]).addClass("open");
        //  if ($("#occhio-static")) {
        //    $("#occhio-static").zoom();
        //  }
        //}
      });
    }

    for (let i = 0; i < $(".js-level-type").length; i++) {
      let btns = document.querySelectorAll(".js-level-type");
      btns[i].addEventListener("click", (e) => {
        this.currentGameConfig.level = e.currentTarget.dataset.difficulty;
        // console.log(this.currentGameConfig);
        $(".js-istruzioni").hide();
        const g = $(`.js-istruzioni[data-game="${this.currentGameConfig.type}"]`)
        g.show();
        $(".js-step-livello").hide();
      });
    }
    
    $(".js-btn-start-game").on("click", (e) => {
      //console.log(games.length);
      for (let i = 0; i < games.length; i++) {
        //console.log(games[i].dataset.game);
        if (e.currentTarget.dataset.start === games[i].dataset.game) {
          //console.log("entro");
          $(".js-istruzioni").hide();
          this.startGame(games[i]);
          $(games[i]).show();
          $(games[i]).addClass("current-game");
        }
      }      
    });
    // show results
    // $(".js-show-result").on("click", (e) => {
    //   $(".current-game").hide();
    //   $(".js-step-3").show();
    // });
    // play again
    $(".js-btn-restart").on("click", (e) => {
      //console.log("ciao");
      this.resetGame(this.currentGameConfig.type);
      $(".js-step-3").hide();
      $(".js-step-livello").show();
    });
    // close game
    if (document.querySelector(".js-close-game")) {      
      $(".js-close-game").on("click", (e) => {
        $(".js-game-layer").fadeOut();
        $(".js-game-layer-menu").fadeOut();
        $(games).removeClass("current-game");
        //$(game_layer).removeClass("open");
        //$(".js-gl-wrap").attr("style", "display: none;");
        this.resetGame();
      });
    }
    $(".js-btn-close").on("click", (e) => {
      $(".js-game-layer").fadeOut();
      $(".js-game-layer-menu").fadeOut();
      $(games).removeClass("current-game");
      this.resetGame();
    });
  }
  /*
   * TEMP:END
   */

  dispatchInitEvent(evenTyepe) {
    // dispaccio un evento globale
    let ev = new Event(evenTyepe);
    ev.payload = { page: this }
    TheDisp.dispatchEvent(ev);
  }

  get isHomepage() {
    return false;
  }

  doLogout() {
    // console.log('dologout')
    AuthWiz.doLogout("/");
  }
  doLogout() {
    AuthWiz.doLogout("/");
  }

  showPreloader(flag, percent = null) {
    if (flag) {
      if (percent == null) {
        $(".js-percent", $(".js-preloader")).hide();
      } else {
        $(".js-percent", $(".js-preloader")).show();
        $(".js-percent", $(".js-preloader")).text(percent);
      }
      jQuery(".js-preloader").show();
    } else {
      jQuery(".js-preloader").hide();
    }
  }

  static showPreloader(flag, percent = null) {
    if (flag) {
      if (percent == null) {
        $(".js-percent", $(".js-preloader")).hide();
      } else {
        $(".js-percent", $(".js-preloader")).show();
        $(".js-percent", $(".js-preloader")).text(percent);
      }
      jQuery(".js-preloader").show();
    } else {
      jQuery(".js-preloader").hide();
    }
  }

  static disable(mc, lFlag, opacity = 0.5) {
    if (lFlag) {
      mc.css("pointer-events", "none");
      mc.css("opacity", opacity);
    } else {
      mc.css("pointer-events", "all");
      mc.css("opacity", 1);
    }
  }
}